import React from 'react';
import { useTranslation } from 'react-i18next';
import './privacy.scss';

function PrivacyPolicy() {
  const { t } = useTranslation();

  return (
    <div className="privacy-page">
      <div className="privacy-container">
        <h1>{t('privacy.title')}</h1>
        <p>{t('privacy.intro')}</p>

        <h2>{t('privacy.law_title')}</h2>
        <p>{t('privacy.law_text')}</p>

        <h2>{t('privacy.collect_title')}</h2>
        <ul>
          <li>{t('privacy.collect_item_1')}</li>
          <li>{t('privacy.collect_item_2')}</li>
          <li>{t('privacy.collect_item_3')}</li>
          <li>{t('privacy.collect_item_4')}</li>
        </ul>

        <h2>{t('privacy.use_title')}</h2>
        <ul>
          <li>{t('privacy.use_item_1')}</li>
          <li>{t('privacy.use_item_2')}</li>
          <li>{t('privacy.use_item_3')}</li>
          <li>{t('privacy.use_item_4')}</li>
        </ul>

        <h2>{t('privacy.cookies_title')}</h2>
        <p>{t('privacy.cookies_text')}</p>
        <ul>
          <li>{t('privacy.cookies_item_1')}</li>
          <li>{t('privacy.cookies_item_2')}</li>
          <li>{t('privacy.cookies_item_3')}</li>
        </ul>

        <h2>{t('privacy.cookies_manage_title')}</h2>
        <p>{t('privacy.cookies_manage_text')}</p>

        <h2>{t('privacy.google_title')}</h2>
        <p>{t('privacy.google_text')}</p>
        <p>
          {t('privacy.google_links_intro')}{' '}
          <a
            href="https://policies.google.com/technologies/partner-sites"
            target="_blank"
            rel="noreferrer"
          >
            policies.google.com/technologies/partner-sites
          </a>{' '}
          {t('privacy.google_links_and')}{' '}
          <a href="https://adssettings.google.com" target="_blank" rel="noreferrer">
            adssettings.google.com
          </a>.
        </p>

        <h2>{t('privacy.sharing_title')}</h2>
        <p>{t('privacy.sharing_text')}</p>

        <h2>{t('privacy.retention_title')}</h2>
        <p>{t('privacy.retention_text')}</p>

        <h2>{t('privacy.rights_title')}</h2>
        <ul>
          <li>{t('privacy.rights_item_1')}</li>
          <li>{t('privacy.rights_item_2')}</li>
          <li>{t('privacy.rights_item_3')}</li>
          <li>{t('privacy.rights_item_4')}</li>
          <li>{t('privacy.rights_item_5')}</li>
        </ul>

        <h2>{t('privacy.choices_title')}</h2>
        <ul>
          <li>{t('privacy.choices_item_1')}</li>
          <li>{t('privacy.choices_item_2')}</li>
        </ul>

        <h2>{t('privacy.security_title')}</h2>
        <p>{t('privacy.security_text')}</p>

        <h2>{t('privacy.changes_title')}</h2>
        <p>{t('privacy.changes_text')}</p>

        <h2>{t('privacy.contact_title')}</h2>
        <p>
          {t('privacy.contact_text')}{' '}
          <a href="mailto:contato@allenty.com">contato@allenty.com</a>.
        </p>
      </div>
    </div>
  );
}

export default PrivacyPolicy;
